import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistractorComponent } from '../../molecules/distractor/distractor.component';
import { Distractor } from '../../../shared/interfaces/distractor.interface';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { LinkComponent } from '../../atoms/link/link.component';
import { ExpandComponent } from '../../molecules/expand/expand.component';
import { Link } from '../../../shared/interfaces/link.interface';
import { Expand } from '../../../shared/interfaces/expand.interface';
import { CapitalizePipe } from '../../capitalize.pipe';
import { HrefType } from '../../../shared/enums/href-type.enums';
import LinkType from '../../../shared/enums/link-type.enums';

@Component({
  selector: 'hdi-distractor-section',
  standalone: true,
  imports: [
    DistractorComponent,
    CommonModule,
    LinkComponent,
    ExpandComponent,
    CapitalizePipe,
  ],
  templateUrl: './distractor-section.component.html',
  styleUrls: ['./distractor-section.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class DistractorSectionComponent {
  @Input() headline?: string;
  @Input() distractor?: Distractor;
  @Input() paragraph?: {
    topText?: string;
    bottomText?: string;
  };
  @Input() linkBox?: { linkText: string; link: Link };
  @Input() list?: string[];
  @Input() expand?: Expand;

  public readonly ViewportType = ViewportType;
  public readonly HrefType = HrefType;
  public readonly LinkType = LinkType;
}
